import { render, staticRenderFns } from "./ProductLocalized.vue?vue&type=template&id=a8489aca"
import script from "./ProductLocalized.vue?vue&type=script&lang=js"
export * from "./ProductLocalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports